import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  GraduationCap, 
  UserCog,
  BookOpen,
  Brain,
  Languages,
  Trophy,
  AlertTriangle,
  UserCheck,
  Calendar,
  FileText,
  Scale
} from 'lucide-react';

const Sidebar = () => {
  const menuItems = [
    {
      section: 'Asosiy',
      items: [
        { path: '/dashboard', icon: LayoutDashboard, label: 'Bosh sahifa', exact: true },
      ]
    },
    {
      section: 'Foydalanuvchilar',
      items: [
        { path: '/dashboard/teachers', icon: UserCog, label: "O'qituvchilar" },
        { path: '/dashboard/students', icon: GraduationCap, label: 'Talabalar' },
        { path: '/dashboard/groups', icon: Users, label: 'Guruhlar' },
      ]
    },
    {
      section: "Ta'lim",
      items: [
        { path: '/dashboard/courses', icon: BookOpen, label: 'Fanlar' },
        { path: '/dashboard/clubs', icon: Trophy, label: "To'garaklar" },
        { path: '/dashboard/events', icon: Calendar, label: "Ma'naviy-ma'rifiy" },
      ]
    },
    {
      section: 'Testlar',
      items: [
        { path: '/dashboard/temperament', icon: Brain, label: 'Temperament' },
        { path: '/dashboard/suicide-test', icon: Brain, label: 'Psixologik test' },
        { path: '/dashboard/language', icon: Languages, label: 'Til bilish' },
        { path: '/dashboard/certificates', icon: FileText, label: 'Sertifikatlar' },
      ]
    },
    {
      section: 'Xabarlar',
      items: [
        { path: '/dashboard/leadership', icon: UserCheck, label: 'Rahbariyat' },
        { path: '/dashboard/corruption', icon: AlertTriangle, label: 'Korrupsiya' },
        { path: '/dashboard/regulations', icon: Scale, label: 'Nizom va hukumat qarorlari' },
      ]
    }
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <img src="/logo.png" alt="BXTT" />
          </div>
          <div>
            <h2>BXTT</h2>
            <span>Admin Panel</span>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((section, idx) => (
          <div key={idx} className="nav-section">
            <div className="nav-section-title">{section.section}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.exact}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
